<template>
  <div
    data-qa="club_pending_payment"
    class="w-100"
  >
    <h1 class="text-h5 text--text text-center mb-4">
      Оплатите
      <template v-if="!cardDateEnd && cardPrice">
        доступ к клубу и
      </template>
      опцион на скидку
    </h1>
    <div class="text-subtitle-1 text-center text-error--text mb-6">
      Иначе запись отменится через
      <time
        data-qa="club__nodeTimer"
        class="expire-time-box"
      />
    </div>
    <div class="d-flex flex-column align-center gr-4">
      <EmailForm
        v-if="!hasEmail"
        v-model="isOpenedEmailForm"
        @cancel="isOpenedEmailForm = false"
        @submit="createCouponRequest"
      />
      <v-btn
        data-qa="club__nodeButtonPayment"
        color="primary"
        :class="{ 'w-100': isMobile }"
        depressed
        @click="handlePayment"
      >
        Оплатить {{ getFormattedPrice(totalPrice) }}
      </v-btn>
      <AgreementInfo />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import { useExpireTime } from 'src/composables/useExpireTime'
import getFormattedPrice from 'www/utils/get/getFormattedPrice'
import { alertUserErrors } from 'www/vue_components/common/Club/functions'
import type {
  ApiCouponRequestPostResponse,
} from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/api/apiCouponRequest.types'
import apiCouponRequest from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/api/apiCouponRequest'
import AgreementInfo from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/components/AgreementInfo.vue'
import EmailForm from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentScreens/components/ClubPendingPayment/components/EmailForm.vue'

const props = defineProps<{
  couponRequestId?: number | string | null
  totalPrice: number | string
  cardPrice?: number | string | null
  lifeTimeSeconds?: number | string | null
  hasEmail?: boolean
}>()

type Emits = {
  (_event: 'club:prepayment', _value: { event: PointerEvent }): void
  (_event: 'club:send-email-success', _value: { response: ApiCouponRequestPostResponse }): void
  (_event: 'club:click-payment', _value: { response: ApiCouponRequestPostResponse }): void
  (_event: 'club:countdown-expired'): void
}

const emit = defineEmits<Emits>()

const isMobile = window.MOBILE_VERSION
const { cardDateEnd } = window.USER.club
const isOpenedEmailForm = ref(false)

async function createCouponRequest(email?: string) {
  if (!props.couponRequestId) {
    return
  }

  try {
    const { data } = await apiCouponRequest.post({
      data: { email },
      couponRequestId: props.couponRequestId,
    })

    if (email) {
      emit('club:send-email-success', { response: data })
    } else {
      emit('club:click-payment', { response: data })
    }
  } catch (error: any) {
    alertUserErrors(error?.response?.data || {})
  }
}

function handlePayment(event: PointerEvent) {
  if (props.hasEmail) {
    createCouponRequest()
  } else {
    isOpenedEmailForm.value = true
    emit('club:prepayment', { event })
  }
}

onMounted(() => {
  useExpireTime({
    offsetSeconds: Number(props.lifeTimeSeconds ?? 0) || 0,
    mountSelector: '.expire-time-box',
    afterCountdown: () => {
      emit('club:countdown-expired')
    },
  })
})
</script>
